import {ChipTypeMap} from "@mui/material/Chip/Chip";
import {OrderStatus} from "../../app/api/model/order";
import {Chip} from "@mui/material";
import {CellContent} from "../../components/ExTable";
import {getTranslation, TranslationContext} from "../../utils/getTranslationKey";
import {TFunction} from "i18next";
import {lowerCase} from "lodash";
import {ShipmentStatus} from "../../app/api/model/shipment";
import {EetsDevicStatus} from "../../app/api/model/eetsDevice";
import {Colors} from "../../components/Layout/Colors";

export const getStatusLabel = (
    status: EetsDevicStatus | ShipmentStatus | OrderStatus,
    t: TFunction,
    context: TranslationContext = TranslationContext.EETS_STATUS,
    size: ChipTypeMap["props"]["size"] = "small"
): CellContent => {
    const translatedStatus = getTranslation({
        context,
        value: lowerCase(status),
        t,
    });

    let returnContent;

    switch (status) {
        case ShipmentStatus.SHIPMENT_CREATED:
        case OrderStatus.SHIPMENT_CREATED:
            returnContent = <Chip label={translatedStatus} color={"success"} size={size} variant="outlined" />;

            break;
        case ShipmentStatus.NEW:
        case EetsDevicStatus.NEW:
            returnContent = <Chip label={translatedStatus} color={"info"} size={size} variant="outlined" />;
            break;
        case EetsDevicStatus.LOCKED:
            returnContent = <Chip label={translatedStatus} color={"error"} size={size} />;
            break;
        case ShipmentStatus.CANCELED:
        case EetsDevicStatus.CANCELED:
        case OrderStatus.CANCELED:
            returnContent = (
                <Chip label={translatedStatus} sx={{borderColor: Colors.GRAY_115}} size={size} variant="outlined" />
            );
            break;
        case ShipmentStatus.SHIPPED:
        case ShipmentStatus.CONFIRMED:
        case EetsDevicStatus.ACTIVE:
        case OrderStatus.NEW:
            returnContent = <Chip label={translatedStatus} color={"success"} size={size} />;
            break;
        default:
            returnContent = <Chip label={translatedStatus} color={"info"} size={size} variant="outlined" />;
            break;
    }

    return {
        title: translatedStatus,
        node: returnContent,
    };
};
